import {
  ToolbarPopoverButton,
  ToolbarPopoverSwitchRow,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.popover";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { useMorphemeFavoriteToggle } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.card-actions";

const FAVORITE_ICON_COLOR = "#eab308";

/**
 * The panel toolbar's Favorite pill. Like every tray pill it opens a popover; the favorite state
 * is the popover's switch, and the pill's label and star colour report it.
 */
export function StarIconButton() {
  const [grapheme] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data.grapheme,
  );
  const { isFavorited, isPending, toggle } = useMorphemeFavoriteToggle();
  return (
    <ToolbarPopoverButton
      accessibilityLabel={isFavorited ? "Remove from Favorites" : "Add to Favorites"}
      iconColor={isFavorited ? FAVORITE_ICON_COLOR : undefined}
      iconSize={16}
      label="Favorite"
      name="FiStar"
      testID="morpheme-favorite-button"
    >
      <ToolbarPopoverSwitchRow
        checked={isFavorited}
        description={`Keeps ${grapheme} in your Favorites collection.`}
        disabled={isPending}
        label="Favorite"
        onCheckedChange={toggle}
        testID="morpheme-favorite-switch"
      />
    </ToolbarPopoverButton>
  );
}
